module.exports = __webpack_public_path__ + "media/assets/icons/choicepoint-img1-d0c4fee5eb3ecb5cdfb8cf2fa2ef226a.svg";